import { ReactElement, ReactNode, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateShape as ReduxStateShape } from '../../reducers';
import { actionCreators } from '../../reducers/pages';
import { VersionsAccordionGroup } from '../BaseComponents';
import AddNewPageForm from './AddNewPageForm';
import AddNewFolderForm from './AddNewFolderForm';

interface PagesRightSidebarProps {
    addNewPage: boolean;
    urlState: string;
    addNewFolder: boolean;
}

const PagesRightSidebar = (props: PagesRightSidebarProps): ReactElement & ReactNode => {
    const { addNewPage, urlState, addNewFolder } = props;
    const [accordionActiveKey, setAccordionActiveKey] = useState('');
    const { items, selectedPages, itemVersions, itemVersionsLoading, revertedVersion } =
        useSelector((state: ReduxStateShape) => state.adminPages);
    const dispatch = useDispatch();

    const onClickAccordion = (eventKey: string) => {
        if (eventKey === '1' && selectedPages.length === 1) {
            dispatch(actionCreators.loadPageVersions(selectedPages[0]));
        }

        if (eventKey && eventKey !== accordionActiveKey) {
            setAccordionActiveKey(eventKey);
        } else {
            setAccordionActiveKey('');
        }
    };

    const onClickRestoreVersion = (eventKey: string) => {
        dispatch(actionCreators.revertPageVersions(selectedPages[0], eventKey));
    };

    useEffect(() => {
        setAccordionActiveKey('0');

        if (revertedVersion && selectedPages.length === 1) {
            dispatch(actionCreators.loadPageVersions(selectedPages[0]));
            dispatch(actionCreators.loadPages(''));
        }
    }, [dispatch, selectedPages, revertedVersion]);

    return (
        <>
            {selectedPages.length > 0 && (
                <VersionsAccordionGroup
                    type={'pages'}
                    items={items}
                    itemVersions={itemVersions}
                    accordionActiveKey={accordionActiveKey}
                    itemVersionsLoading={itemVersionsLoading}
                    selectedItems={selectedPages}
                    onClickAccordion={onClickAccordion}
                    onClickRestoreVersion={onClickRestoreVersion}
                    urlState={urlState}
                />
            )}
            {addNewPage && <AddNewPageForm urlState={urlState} />}
            {addNewFolder && <AddNewFolderForm urlState={urlState} />}
        </>
    );
};
export default PagesRightSidebar;
